exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-static-template-js": () => import("./../../../src/templates/staticTemplate.js" /* webpackChunkName: "component---src-templates-static-template-js" */)
}

